import React, { useState } from 'react';
import { Check } from 'lucide-react';
import ContactPopup from './ContactPopup';

const PricingTable = () => {
  const [showPopup, setShowPopup] = useState(false);

  const plans = [
    {
      name: 'Essentials',
      price: '$45',
      fee: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Basic Search',
        'State E-Filing',
        'Trademark Secured',
      ],
      note: '(Govt. filing fee not included)',
      recommended: false,
    },
    {
      name: 'Enhanced',
      price: '$149',
      fee: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
      ],
      note: '(Govt. filing fee not included)',
      recommended: false,
    },
    {
      name: 'Deluxe',
      price: '$299',
      fee: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Trademark Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager',
      ],
      note: '(Govt. filing fee not included)',
      recommended: true,
    },
    {
      name: 'Platinum',
      price: '$349',
      fee: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Trademark Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager',
        'High Approval Rate',
        'Comprehensive Search Report',
        'High Priority Service',
        'Cease & Desist Letter',
      ],
      note: '(Govt. filing fee not included)',
      recommended: false,
    },
  ];

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`bg-white rounded-2xl shadow-lg p-6 flex flex-col relative transform hover:scale-105 transition-all ${
              plan.recommended ? 'border-4 border-indigo-500 shadow-2xl' : 'border border-gray-200'
            }`}
            data-testid={`pricing-plan-${plan.name.toLowerCase()}`}
          >
            {plan.recommended && (
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-1 rounded-full text-sm font-semibold shadow-lg">
                  Recommended
                </span>
              </div>
            )}
            
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-dark)' }}>
                {plan.name}
              </h3>
              <div className="mb-2">
                <span className="text-4xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                  {plan.price}
                </span>
              </div>
              <p className="text-sm text-gray-600">{plan.fee}</p>
            </div>

            <div className="flex-1 mb-6">
              <div className="max-h-64 overflow-y-auto scrollbar-thin scrollbar-thumb-orange-500 scrollbar-track-gray-100">
                <ul className="space-y-3">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <Check className="text-indigo-600 mr-2 flex-shrink-0" size={20} />
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <p className="text-xs text-gray-500 mt-4 text-center">{plan.note}</p>
            </div>

            <button
              onClick={() => setShowPopup(true)}
              className={`w-full py-3 rounded-lg font-semibold transition-all ${
                plan.recommended
                  ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:from-indigo-700 hover:to-purple-700 shadow-lg'
                  : 'bg-white border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50'
              }`}
              data-testid={`pricing-select-${plan.name.toLowerCase()}`}
            >
              Select Plan
            </button>
          </div>
        ))}
      </div>

      {showPopup && <ContactPopup onClose={() => setShowPopup(false)} source="popup" />}
    </>
  );
};

export default PricingTable;